<template>
    <ValidationObserver ref="observer" slim>
        <div>
            <p id="emailText" class="radioStyle">{{$t('pages.selfservice.headers.reset.emailtitle')}}</p>
            <div id="radio-group" v-show=this.$route.query.otp class="form-row form-group mb-0 radioStyle">
                <b-card-body slot="center-card-body" style="padding: 0rem 0rem 1rem 0rem !important;">
                    <input type="radio" id="Email" value="Email" v-model="picked" class="radio-custom" checked v-on:click="rdoChange('Email')">
                    <label for="Email" class="radio-custom-label">{{$t(`pages.selfservice.headers.reset.email`)}}</label>
                    <div data-v-7a45a1b0="" for="Email" style="padding-bottom:.5rem"></div>
                    <input type="radio" id="SMS" value="SMS" v-model="picked" class="radio-custom" v-on:click="rdoChange('SMS')">
                    <label for="SMS" class="radio-custom-label">{{$t(`pages.selfservice.headers.reset.sms`)}}</label>
                    <div data-v-7a45a1b0="" for="SMS" style="padding-bottom:.5rem"></div>
                    <input type="radio" id="KBA" value="KBA" v-model="picked" class="radio-custom" v-on:click="rdoChange('KBA')">
                    <label for="KBA" class="radio-custom-label">{{$t(`pages.selfservice.headers.reset.secQus`)}}</label>
                    <div data-v-7a45a1b0="" for="KBA" style="padding-bottom:.5rem"></div>
                </b-card-body>
            </div>
            <fr-floating-label-input
                v-model="uid"
                :placeholder="(qGlobalId || qIactiveId) && !faethmId ? $t('pages.selfservice.passwordReset.enterYourEmailAddress') : ''"
                :validateRules="'required|max:64'"
                fieldName="uid"
                :label="lableName"
                type="text"
                data-vv-validate-on="submit">
            </fr-floating-label-input>
            <fr-loading-button type="button"
                            ref="submitButton"
                            :label=this.btnText
                            :loading="loading"
                            :disabled="loading"
                            :large="true"
                            @click="submitForm"/>
            <!-- <div id="otp-div" class="pull-right"  style="text-align:right;">
                <fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp" style="display:inline-block!important;"
                            :label="$t('common.form.cancel')"
                            :large="true"
                            @click="$router.go(-1)"></fr-loading-button>
                <fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp" style="display:inline-block!important;"
                            :label=this.btnText
                            :loading="loading"
                            :large="true"
                            @click="save"></fr-loading-button>
            </div> -->
            <Captcha v-if="selfServiceDetails.requirements.recaptcha && !automationToken" :self-service-details="selfServiceDetails" ref="recaptcha"
                @captcha-loading="handleCaptchaLoading"
                @captcha-ready="handleCaptchaReady"></Captcha>
        </div>
    </ValidationObserver>
</template>

<script>
import _ from 'lodash';
import FloatingLabelInput from '@/components/utils/FloatingLabelInput';
import LoadingButton from '@/components/utils/LoadingButton';
import { getClientById } from '../../../lib/getClientById';
import { getParams } from '../../../lib/URLUtils';

/**
 * @description Selfservice stage for multiple selfservice flows, attempts to auto generate a form for a user to fill out. Currently
 * generates only numbers, strings and boolean fields. This stage will only load when no other stage is found.
 *
 **/
export default {
    name: 'Reset-Self-Service',
    props: {
        selfServiceDetails: { required: true }
    },
    components: {
        'fr-floating-label-input': FloatingLabelInput,
        'fr-loading-button': LoadingButton,
        Captcha: () => import('../common/Captcha')
    },
    mounted () {
        if (typeof window.gaEvent === 'function') {
            window.gaEvent('Forgot password', 'Forgot password', 'Render', 'page rendered.');
        }
        this.titleMsg = this.$t('pages.selfservice.headers.reset.emailtitle');
        this.btnText = this.$t('common.form.submit');
        const clientIdKey = this.getQueryStringValue('client_id');
        const setPasswordKey = this.getQueryStringValue('setPassword');
        let userNameParam = this.getQueryStringValue('poidata');
        if (userNameParam !== null) {
            try {
                userNameParam = atob(userNameParam);
            } catch (e) {
                console.error('Failed to decode poidata:', e);
                userNameParam = null;
            }
        }
        // If poidata is not present or decoding fails, try to get userName from query string
        if (userNameParam === null) {
            userNameParam = this.getQueryStringValue('userName');
        }
        if (clientIdKey === 'PVS-Client' && clientIdKey !== null && setPasswordKey !== null &&
         setPasswordKey === 'true') {
            if (userNameParam !== null) {
                this.uid = userNameParam;
            }
            const customPasswordElement = document.getElementById('custom-password');
            const setPasswordElement = document.getElementById('set-pwd');
            const forgotPasswordElement = document.getElementById('forgot-pwd');
            const forgotTextElement = document.getElementById('forgot-text');
            const setTextElement = document.getElementById('set-text');

            if (customPasswordElement !== null && setPasswordElement !== null && forgotPasswordElement !== null && forgotTextElement !== null && setTextElement !== null) {
                customPasswordElement.style.display = 'none';
                setPasswordElement.style.display = 'block';
                forgotPasswordElement.style.display = 'none';
                forgotTextElement.style.display = 'none';
                setTextElement.style.display = 'block';
            }
        }

        if (this.getQueryStringValue('uid') && this.getQueryStringValue('isLinkingAccounts') === 'true') {
            this.submitForm();
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    data () {
        let saveData = {},
            btnText = this.$t('common.form.submit'),
            titleMsg = this.$t('pages.selfservice.headers.reset.emailtitle');
        const gotoUrl = this.getQueryStringValue('goto');
        const clientId = this.getQueryStringValue('client_id') || getClientById();
        const spEntityID = this.getQueryStringValue('spEntityID') || getClientById();
        const id = clientId || spEntityID;
        const isLinkingAccounts = this.getQueryStringValue('isLinkingAccounts') === 'true';
        return {
            saveFields: saveData,
            picked: 'Email',
            btnText: btnText,
            titleMsg: titleMsg,
            uid: this.$route.query.uid ? decodeURIComponent(atob(this.$route.query.uid)) : '',
            isLinkingAccounts: isLinkingAccounts,
            recaptchaToken: undefined,
            successUrl: gotoUrl,
            qGlobalId: id?.includes('QGlobal'),
            qIactiveId: id?.includes('qiactive'),
            faethmId: id?.includes('faethm'),
            bobClientId: id?.includes('BOB_Client'),
            gedManagerId: id?.includes('ged-client'),
            gedStudentId: id?.includes('ged-student-client'),
            lableName: this.getLableName(id),
            loading: false,
            automationToken: getParams().get('automationToken')
        };
    },
    methods: {
        handleCaptchaLoading () {
            const submitButton = this.$refs.submitButton;
            if (!submitButton) {
                console.log('Submit button ref is null; skip disabling while captcha loads');
                return;
            }

            this.loading = true;
            console.log('Submit button disabled until grecaptcha is ready');
        },
        handleCaptchaReady () {
            const submitButton = this.$refs.submitButton;
            if (!submitButton) {
                console.log('Submit button ref is null; skip enabling after captcha ready');
                return;
            }

            this.loading = false;
            console.log('Submit button enabled because grecaptcha is ready');
        },
        submitForm () {
            if (this.selfServiceDetails.requirements.recaptcha && !this.automationToken) {
                this.$refs.recaptcha.executeScore('resetPassword')
                    .then((token) => {
                        this.recaptchaToken = token;
                        this.save();
                    }).catch((e) => {
                        console.log('Recaptcha error: ' + e);
                        this.loading = false;
                    });
            } else {
                this.save();
            }
        },
        created () {
        },
        rdoChange: function (control) {
            if (typeof window.gaEvent === 'function') {
                window.gaEvent('Forgot password', 'Forgot password', control, `Reset method selected`);
            }
            if (control === 'Email') {
                this.titleMsg = this.$t('pages.selfservice.headers.reset.emailtitle');
                this.btnText = this.$t('common.form.submit');
            } else if (control === 'SMS') {
                this.titleMsg = this.$t('pages.selfservice.headers.reset.otptitle');
                this.btnText = this.$t('common.form.sendotp');
            } else if (control === 'KBA') {
                this.titleMsg = this.$t('pages.selfservice.headers.reset.secQustitle');
                this.btnText = this.$t('common.form.submit');
            }
        },
        getData () {
            this.saveFields.userName = this.uid;
            this.saveFields.sendingMethod = this.picked.toUpperCase();
            // if (this.$route.query.realm === undefined) {
            //     this.saveFields.realm = 'PEARSON';
            // } else {
            //     this.saveFields.realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
            // }
            this.saveFields.queryFilter = 'uid eq ' + '\'' + this.uid + '\'';
            if (this.faethmId) {
                this.saveFields.branding = 'FAETHM';
            } else if (this.bobClientId) {
                this.saveFields.branding = 'bob';
            } else if (this.gedManagerId) { // IAMNE - 703 Custom Reset Password Template for GED
                this.saveFields.branding = 'ged';
            } else if (this.$route.query.realm === undefined) {
                this.saveFields.branding = 'PEARSON';
            } else {
                this.saveFields.branding = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
            }
            this.saveFields.clientId = getClientById();
            if (this.automationToken) {
                this.saveFields.automationToken = this.automationToken;
                this.saveFields.recaptchaToken = 'automation token provided';
            } else if (this.recaptchaToken) {
                this.saveFields.recaptchaToken = this.recaptchaToken;
            }

            // Add the isLinkingAccounts flag if it exists
            if (this.isLinkingAccounts) {
                this.saveFields.isLinkingAccounts = true;
            }

            this.saveFields.successUrl = this.successUrl;
            return this.saveFields;
        },
        getQueryStringValue (name) {
            let url = window.location.href;
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex;
            if (name.toLowerCase() === 'username') {
                regex = new RegExp(regexS, 'i'); // Add 'i' flag for case insensitivity
            } else {
                regex = new RegExp(regexS);
            }
            let results = regex.exec(url);
            return results == null ? null : decodeURIComponent(results[1]);
        },
        getLableName (id) {
            if (id && (id.includes('QGlobal') || id.includes('qiactive'))) {
                return this.$t('pages.selfservice.passwordReset.username');
            } else {
                return this.$t('pages.selfservice.passwordReset.username');
            }
        },
        save () {
            this.loading = true;
            this.isValidAll().then((valid1) => {
                this.isValid().then((valid) => {
                    if (valid1) {
                        if (typeof window.gaEvent === 'function') {
                            window.gaEvent('Forgot password', 'Forgot password', 'Submit', 'Submit button clicked.');
                        }
                        this.$emit('advanceStage', this.getData());
                    } else {
                        this.loading = false;
                    }
                }).catch(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.loading = false;
            });
        },
        isValid () {
            return Promise.resolve(true);
        },
        isValidAll () {
            /* istanbul ignore next */
            return this.$refs.observer.validate();
        }
    },
    filters: {
        startCase (value) {
            return _.startCase(value);
        }
    },
    watch: {
    // whenever question changes, this function will run
        loading: function () {
            // alert(this.loading);
        }
    }
};
</script>

<style scoped>
@import '../../../scss/pearson-common.css';
</style>
